"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRequestPlanningItemCreateBody = void 0;
const iplanning_item_entity_1 = require("./iplanning-item-entity");
function parseRequestPlanningItemCreateBody(data) {
    if (data.planningItem !== null && typeof data.planningItem === 'object')
        data.planningItem = (0, iplanning_item_entity_1.parseIPlanningItemEntity)(data.planningItem);
    return data;
}
exports.parseRequestPlanningItemCreateBody = parseRequestPlanningItemCreateBody;
